export default function (context) {
	// If the user is not authenticated
	if (context.$cookie.get('token')) {
		return context.redirect('/');
	}
}